"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTravelRooms = void 0;
const noop_1 = __importDefault(require("lodash/noop"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_forms_1 = require("@hotelplan/components.common.forms");
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const libs_sx_1 = require("@hotelplan/libs.sx");
const TravelRooms_utils_1 = require("./TravelRooms.utils");
const useTravelRooms = (isSearchForFourRoomsEnabled) => {
    const [travelRooms, setTravelRooms] = (0, components_common_forms_1.useField)('travelRooms');
    return {
        value: travelRooms,
        setValue: setTravelRooms,
        isValid: travelRooms
            ? (0, TravelRooms_utils_1.isTravelRoomsValid)(travelRooms, isSearchForFourRoomsEnabled)
            : false,
        isEmpty: travelRooms ? (0, TravelRooms_utils_1.hasTravelRoomsEmptyDates)(travelRooms) : false,
    };
};
exports.useTravelRooms = useTravelRooms;
const TravellersTextInput = (0, styled_components_1.default)(components_common_text_input_1.TextInput)((0, libs_sx_1.sx2CssThemeFn)({
    mb: [2, 0],
}));
const TravelRoomsField = ({ inputRef, inputValue, inputIcon, children, onClick, customLabel, onKeyPress, className, }) => {
    const [t] = (0, next_i18next_1.useTranslation)('search');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TravellersTextInput, { variant: "inputs.searchControlField", "data-id": "travelersInput", className: `travelersInput ${className ? className : ''}`, inputRef: inputRef, name: "travelers", label: t('search:rooms.travelers.label'), customLabel: customLabel, hideLabel: true, readOnly: true, value: inputValue, onChange: noop_1.default, onClick: onClick, icon: inputIcon, onKeyPress: onKeyPress }),
        children));
};
exports.default = TravelRoomsField;
//# sourceMappingURL=TravelRoomsField.js.map